<template>
  <div class="case-list">
    <div class="swiper-container case-list__swiper" ref="swiperContainer">
      <div class="swiper-wrapper">
        <div
          v-for="(item, index) in caseList"
          :key="index"
          class="swiper-slide case-list__slide"
        >
          <div class="case-list__card" @click="handleClick(item)">
            <div class="case-list__card__image">
              <img :src="item.image" :alt="item.title" />
            </div>
            <div class="case-list__card__content">
              <div class="case-list__card__title">{{ item.title }}</div>
              <div class="case-list__card__description">{{ item.description }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-button-prev case-list__arrow case-list__arrow--prev">
        <img src="@/assets/images/home/arrow-left.png" alt="arrow-left" />
      </div>
      <div class="swiper-button-next case-list__arrow case-list__arrow--next">
        <img src="@/assets/images/home/arrow-right.png" alt="arrow-right" />
      </div>
    </div>
  </div>
</template>

<script>
import Swiper, { Navigation, Autoplay } from 'swiper';
import 'swiper/swiper-bundle.css';

Swiper.use([Navigation, Autoplay]);

export default {
  name: "CaseList",
  props: {
    caseList: {
      type: Array,
      default: () => []
    },
    height: {
      type: String,
      default: "400px"
    }
  },
  data() {
    return {
      swiper: null
    };
  },
  mounted() {
    this.initSwiper();
  },
  beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  },
  watch: {
    caseList: {
      handler() {
        this.$nextTick(() => {
          if (this.swiper) {
            this.swiper.update();
          } else {
            this.initSwiper();
          }
        });
      },
      deep: true
    }
  },
  methods: {
    initSwiper() {
      if (!this.$refs.swiperContainer) {
        return;
      }
      
      this.swiper = new Swiper(this.$refs.swiperContainer, {
        slidesPerView: 3,
        spaceBetween: 20,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: 2500, // 2.5秒切换
          disableOnInteraction: false, // 用户操作后不停止
          pauseOnMouseEnter: true, // 鼠标悬停时暂停
        },
      });
    },
    handleClick(item) {
      //新增浏览器tab页打开路由页面
      const routeData = this.$router.resolve({ name: 'case', params: { id: item.id } });
      window.open(routeData.href, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.case-list {
  width: 1042px;
  margin:0 auto;
  position:relative;
  background: linear-gradient(180deg, #F4F5F7 0%, rgba(244, 245, 247, 0) 100%);
  &__swiper {
    width:100%;
    height: 100%;
  }

  &__slide {
    width:334px;
  }


  &__arrow {
    background-color: transparent;
    width: 65px;
    height: 65px;
    z-index: 10;
    margin-top: 0;
    top: 50%;
    transform: translateY(-50%);

    img{
      width: 100%;
      height:100%;
    }

    &::after {
      display: none;
    }

    &--prev {
      left: -96px;
    }

    &--next {
      right: -96px;
    }
  }

  &__card {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    overflow: hidden;
    background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
    box-shadow: 0px 0px 11px 0px rgba(40, 51, 68, 0.06);

    cursor: pointer;

    &__image {
      width: 100%;
      height: 187px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.3s ease;
      }
    }

    &__content {
      padding: 16px;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      height: 128px;
      
   
    }

    &__title {
      font-size: 18px;
      font-weight: 600;
      line-height: normal;
      letter-spacing: normal;
      color: #262626;
      margin-bottom: 12px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__description {
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: normal;
      color: #595959;

      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

::v-deep .swiper-button-disabled {
  display: none;
}

::v-deep .swiper-container{
  position:unset;
}
</style>
